import { handleSessionLessApi } from './common';

const API_ENDPOINT = {
	getGuestScripPriceFlash: ({
		scripToken = '',
		marketSegmentId = '',
		isIndex = '',
	}) =>
		`PriceForGuest?token=${scripToken}&segment_id=${marketSegmentId}&is_index=${isIndex}`,
};

export const getGuestScripDetailV2 = async (
	Api,
	scripToken = '',
	marketSegmentId = '',
	isIndex = 0,
) => {
	const response = await Api.get(
		API_ENDPOINT.getGuestScripPriceFlash({
			scripToken,
			marketSegmentId,
			isIndex,
		}),
	);
	const result = handleSessionLessApi(response);
	return result;
};
